import * as Sentry from '@sentry/nextjs';
import clarity from '@microsoft/clarity';

const ALLOWED_DOMAINS = ['about.roblox.com'];

Sentry.init({
  dsn: 'https://ce3675c61d9cce288c365bb64536367b@o293668.ingest.us.sentry.io/4507454410981376',

  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5,

  environment: process.env.NODE_ENV,

  enabled: process.env.NODE_ENV === 'production' || process.env.ENABLE_SENTRY_DEV === 'true',

  debug: process.env.NODE_ENV === 'development',

  beforeSend(event, hint) {
    if (typeof window !== 'undefined') {
      if (!ALLOWED_DOMAINS.includes(window.location.hostname)) {
        return null;
      }
    }

    if (
      event.exception?.values?.[0]?.stacktrace?.frames?.some(
        (frame) =>
          frame.filename?.startsWith('chrome-extension://') ||
          frame.filename?.startsWith('moz-extension://') ||
          frame.filename?.startsWith('safari-extension://') ||
          frame.filename?.startsWith('extension://') ||
          frame.filename?.includes('extension://') ||
          frame.filename?.startsWith('app:///') ||
          frame.filename?.includes('content.js')
      )
    ) {
      return null;
    }

    if (
      event.message?.includes('Non-Error promise rejection captured') ||
      event.message?.includes('Script error') ||
      event.message?.includes('ResizeObserver loop limit exceeded') ||
      event.message?.includes('Evaluation failed: Error: Execution context was destroyed')
    ) {
      return null;
    }

    if (
      event.exception?.values?.[0]?.value?.includes('extension://') ||
      event.exception?.values?.[0]?.value?.includes('chrome-extension://')
    ) {
      return null;
    }

    if (typeof window !== 'undefined') {
      if (
        window.location.hostname?.includes('translate.goog') ||
        window.location.hostname?.includes('translate.google.com')
      ) {
        return null;
      }

      try {
        if (
          window.parent !== window &&
          (window.parent.location.hostname?.includes('translate.goog') ||
            window.parent.location.hostname?.includes('translate.google.com'))
        ) {
          return null;
        }
      } catch (e) {
        // Cross-origin error — might be in translate frame
      }
    }

    if (
      event.message?.includes('translate.goog') ||
      event.message?.includes('translate.google.com') ||
      event.exception?.values?.[0]?.value?.includes('translate.goog') ||
      event.exception?.values?.[0]?.value?.includes('translate.google.com')
    ) {
      return null;
    }

    return event;
  },

  ignoreErrors: [
    'Non-Error promise rejection captured',
    'ResizeObserver loop limit exceeded',
    'Script error',
    /extension\//i,
    /^chrome:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-extension:\/\//i,
    /^app:\/\/\//i,
    /content\.js/i,
    'timeout is not defined',
    'Evaluation failed: Error: Execution context was destroyed',
    'Object Not Found Matching Id',
    /translate\.goog/i,
    /translate\.google\.com/i,
    'gtranslate',
    'google-translate',
  ],
});

// Runs before React mounts, so ConsentProvider resolves too late to gate Clarity (PRIVACY-5234).
if (
  typeof window !== 'undefined' &&
  !document.cookie.split('; ').includes('RBXcp=restricted') &&
  !/RobloxApp\//.test(navigator.userAgent) &&
  process.env.NEXT_PUBLIC_CLARITY_ID &&
  (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_ENABLE_CLARITY_DEV === 'true')
) {
  clarity.init(process.env.NEXT_PUBLIC_CLARITY_ID);
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
export const onRequestError = Sentry.captureRequestError;
